(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-90s-mysterybox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-90s-box')) {
    customElements.define('vs-90s-box', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('invalid', event => event.target.closest('details')?.setAttribute('open', ''), { capture: true, signal: this.controller.signal });
        this.querySelector('[data-preview-form]')?.addEventListener('submit', event => event.preventDefault(), { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-double-drop"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const abort = new AbortController();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches, visible = false, frameId = 0, last = 0;
    const listen = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal: abort.signal });
    const lanes = [...root.querySelectorAll('.vs-dd-lane')].map(lane => {
      const track = lane.querySelector('.vs-dd-track');
      const cards = [...track.children];
      if (cards.length < 2) return { lane, width: 0 };
      cards.forEach(card => { const copy = card.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); copy.querySelectorAll('img').forEach(img => img.alt = ''); copy.tabIndex = -1; track.append(copy); });
      const state = { lane, track, count: cards.length, width: 0, hover: false, focus: false, dragging: false, moved: false, x: 0, direction: Number(lane.dataset.direction) };
      const measure = () => { state.width = track.children[cards.length].offsetLeft - track.children[0].offsetLeft; if (state.direction < 0 && lane.scrollLeft === 0) lane.scrollLeft = (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)) / 2; };
      const resize = new ResizeObserver(measure); resize.observe(lane); state.resize = resize; measure();
      listen(lane, 'pointerenter', e => { if (e.pointerType === 'mouse') state.hover = true; });
      listen(lane, 'pointerleave', () => state.hover = false);
      listen(lane, 'focusin', () => state.focus = true);
      listen(lane, 'focusout', () => state.focus = false);
      listen(lane, 'dragstart', e => e.preventDefault());
      listen(lane, 'pointerdown', e => { state.dragging = true; state.moved = false; state.x = e.clientX; });
      listen(window, 'pointermove', e => { if (!state.dragging) return; const delta = state.x - e.clientX; if (Math.abs(delta) > 3) state.moved = true; lane.scrollLeft += delta; state.x = e.clientX; });
      listen(window, 'pointerup', () => state.dragging = false);
      listen(window, 'pointercancel', () => state.dragging = false);
      listen(lane, 'click', e => { if (state.moved) { e.preventDefault(); state.moved = false; } }, { capture: true });
      return state;
    });
    listen(reduced, 'change', e => { paused = e.matches; });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }); observer.observe(root);
    const offsets = new WeakMap();
    function frame(time) {
      if (!root.isConnected) { abort.abort(); observer.disconnect(); lanes.forEach(s => s.resize?.disconnect()); cancelAnimationFrame(frameId); return; }
      const dt = last ? Math.min((time - last) / 1000, .05) : 0; last = time;
      if (visible && !paused && !document.hidden) lanes.forEach(s => {
        if (!s.width || s.hover || s.focus || s.dragging) { if (s.track) s.track.style.transform = ''; offsets.delete(s.lane); return; }
        let x = offsets.get(s.lane) ?? s.lane.scrollLeft;
        if (Math.abs(x - s.lane.scrollLeft) > 2) x = s.lane.scrollLeft;
        x += dt * Number(root.dataset.speed) * (s.direction > 0 ? 1.35 : 1) * s.direction;
        if (x >= s.width) x -= s.width;
        if (x < 0) x += s.width;
        s.lane.scrollLeft = x;
        // Preserve subpixel movement when WebKit rounds scroll positions.
        s.track.style.transform = 'translate3d(' + (s.lane.scrollLeft - x) + 'px,0,0)';
        offsets.set(s.lane, x);
      });
      frameId = requestAnimationFrame(frame);
    }
    frameId = requestAnimationFrame(frame);
  }
  document.querySelectorAll('.vs-double-drop').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.vs-double-drop').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-metki-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-gang-crew')) {
    customElements.define('vs-gang-crew', class extends HTMLElement {
      connectedCallback() {
        if (this.crewReady) return;
        const button = this.querySelector('button');
        if (!button) return;
        this.crewReady = true;
        this.crewAnimations = [];
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const play = () => {
          this.crewAnimations.forEach(animation => animation.cancel());
          this.crewAnimations = [];
          if (reduced.matches) return;
          const scenes = [
            ['.vsch-gang-crew__friend--scooter', [{transform:'translateX(32px) rotate(3deg)'},{transform:'translateX(-12px) rotate(-2deg)',offset:.7},{transform:'none'}], 2600, 200],
            ['.vsch-gang-crew__friend--bag', [{transform:'none'},{transform:'translateY(-10px) rotate(5deg)',offset:.5},{transform:'none'}], 1800, 600],
            ['.vsch-gang-crew__friend--hoodie', [{transform:'none'},{transform:'rotate(-7deg)',offset:.5},{transform:'none'}], 1600, 900]
          ];
          for (const [selector, frames, duration, delay] of scenes) {
            const element = this.querySelector(selector);
            if (element?.animate) this.crewAnimations.push(element.animate(frames, {duration, delay, easing:'ease-in-out', iterations:1}));
          }
        };
        const preference = () => {
          button.hidden = reduced.matches;
          if (reduced.matches) this.crewAnimations.forEach(animation => animation.cancel());
        };
        button.addEventListener('click', play);
        reduced.addEventListener('change', preference);
        preference();
        if ('IntersectionObserver' in window) {
          this.crewObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { play(); this.crewObserver.disconnect(); }
          }, {threshold:.3});
          this.crewObserver.observe(this);
        }
        this.crewCleanup = () => { button.removeEventListener('click', play); reduced.removeEventListener('change', preference); };
      }
      disconnectedCallback() {
        this.crewObserver?.disconnect();
        this.crewAnimations?.forEach(animation => animation.cancel());
        this.crewCleanup?.();
        this.crewReady = false;
      }
    });
  }
  if (!customElements.get('vs-gang-calculator')) {
    customElements.define('vs-gang-calculator', class extends HTMLElement {
      connectedCallback() {
        const input = this.querySelector('input[type="range"]');
        if (!input || this.gangReady) return;
        this.gangReady = true;
        const update = () => {
          const amount = Number(input.value);
          if (!Number.isFinite(amount) || amount < 0 || amount > 2000) return;
          const rate = Number(this.querySelector('[data-gang-rate]')?.value || 10);
          if (![10, 15, 20].includes(rate)) return;
          const points = Math.floor(Math.round(amount * 100) * rate / 1000);
          this.querySelector('[data-gang-spend]').textContent = String(amount);
          this.querySelector('[data-gang-points]').textContent = String(points);
          this.querySelector('[data-gang-value]').textContent = String(points / 10);
          input.setAttribute('aria-valuetext', `${amount} zł`);
        };
        input.addEventListener('input', update);
        this.querySelector('[data-gang-rate]')?.addEventListener('change', update);
        input.disabled = false;
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-y2k-mysterybox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-y2k-box')) {
    customElements.define('vs-y2k-box', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('invalid', event => event.target.closest('details')?.setAttribute('open', ''), { capture: true, signal: this.controller.signal });
        this.querySelector('[data-preview-form]')?.addEventListener('submit', event => event.preventDefault(), { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
